import { NgModule } from "@angular/core";
import { HomeComponent } from "./components/home/home.component";
import { AddCvComponent } from "./components/add-cv/add-cv.component";
import { RouteDialogComponent } from "./helpers/route-dialog.component";
import { HistoryComponent } from "./components/history/history.component";
import { AboutUsComponent } from "./components/about-us/about-us.component";
import { FAQ } from "./components/faq/FAQ.component";
import { LecturesComponent } from "./components/lectures/lectures.component";
import { OrganisersComponent } from "./components/organisers/organisers.component";
import { SupportersComponent } from "./components/supporters/supporters.component";
import { Route, RouterModule, Routes } from "@angular/router";
import { CompanyStandComponent } from "./components/company-stand/company-stand.component";
import { CatalogueComponent } from "./components/catalogue/catalogue.component";
import { CompanyDashboardComponent } from "./components/company-dashboard/company-dashboard.component";
import { AdsComponent } from "./components/ads/ads.component";

type PathMatch = "full" | "prefix" | undefined;

const routes: Routes = [
  {
    path: "company/:id",
    component: CompanyStandComponent,
  },
  {
    path: "",
    pathMatch: "full" as PathMatch,
    redirectTo: "home",
  } as Route,
  {
    path: "home",
    component: HomeComponent,
    children: [
      ...["login", "register", "reset-password"].map((path) => ({
        path,
        component: RouteDialogComponent,
      })),
    ],
  },
  {
    path: "CV",
    component: AddCvComponent,
  },
  {
    path: "organisers",
    component: OrganisersComponent,
  },
  {
    path: "about-us",
    component: AboutUsComponent,
  },
  {
    path: "supporters",
    component: SupportersComponent,
  },
  {
    path: "lectures",
    component: LecturesComponent,
  },
  {
    path: "history",
    component: HistoryComponent,
  },
  {
    path: "faq",
    component: FAQ,
  },
  {
    path: "catalogue",
    component: CatalogueComponent,
  },
  {
    path: "company-dashboard",
    component: CompanyDashboardComponent,
  },
  {
    path: "ads",
    component: AdsComponent
  },
  /**************************************************************
   * Everything that is not routed above will be routed to home *
   * Meaning: Add routes above this one to make sure they work  *
   **************************************************************/
  {
    path: "**",
    redirectTo: "home",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: "enabled",
    initialNavigation: 'enabledNonBlocking'
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
